import { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

const STATUS_PAGE = 'https://status.evervault.com';
export function MaintenanceRedirect() {
  const flags = useFlags();

  useEffect(() => {
    if (flags.disablePrimaryInstanceWrites) {
      window.location.replace(STATUS_PAGE);
    }
  }, [flags]);

  return null;
}
